import { render, staticRenderFns } from "./Termination.vue?vue&type=template&id=6c802011&scoped=true&"
import script from "./Termination.vue?vue&type=script&lang=js&"
export * from "./Termination.vue?vue&type=script&lang=js&"
import style0 from "./Termination.vue?vue&type=style&index=0&id=6c802011&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c802011",
  null
  
)

export default component.exports